import React from 'react'

export const CloseIcon: React.FC = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.94289 7.99998L13.8048 3.13808L12.862 2.19527L8.00008 7.05717L3.13818 2.19527L2.19537 3.13808L7.05727 7.99998L2.19531 12.8619L3.13812 13.8047L8.00008 8.94278L12.862 13.8047L13.8049 12.8619L8.94289 7.99998Z"
        fill="#220C4A"
      />
    </svg>
  )
}

export default CloseIcon
